import type { IconOwnProps } from '@ps/isp-web-component-library';
import { Icon } from '@ps/isp-web-component-library';
import { Star } from '@ps/isp-web-component-library/icons/Star';
import { StarEmpty } from '@ps/isp-web-component-library/icons/StarEmpty';
import type { ClassValue } from 'clsx';
import classnames from 'clsx';
import React from 'react';

import { useRegulatoryIntl } from '@swf/core/hooks/useRegulatoryIntl';

import { TXTWCL_RatingX_N0_out_of_N1_stars } from './StarRating.messages.json';
import styles from './StarRating.scss';

interface Props {
  rating: number;
  size: IconOwnProps['size'];
  isInverted?: boolean;
  className?: ClassValue;
}

const StarRating: React.FC<Props> = ({ rating, size, isInverted = false, className }) => {
  const { formatMessage } = useRegulatoryIntl();
  return (
    <div
      className={classnames(styles.container, className)}
      role="img"
      aria-label={formatMessage(TXTWCL_RatingX_N0_out_of_N1_stars, {
        0: rating,
        1: 5
      })}
    >
      {Array.from({ length: 5 }, (_, i) => (
        <Icon
          icon={i < rating ? Star : StarEmpty}
          size={size}
          key={`star-${i}`}
          className={classnames(styles.star, {
            [styles.inverted]: isInverted
          })}
        />
      ))}
    </div>
  );
};

export { StarRating };
